class HeaderTransparent {
  constructor () {
    this.selectors = {
      siteHeader: '.hd-Header',
      section: '[data-transparent-site-header]',
    }

    this.classes = {
      transparent: 'hd-Header-transparent',
      foregroundLight: 'hd-Header-transparent-foreground-light',
      foregroundDark: 'hd-Header-transparent-foreground-dark',
    }

    this.initialisation()

    document.addEventListener('clear-transparent-header', () => {
      this.removeTransparentState(this.siteHeader)
    })
  }

  initialisation () {
    if (!this.sections) return

    const options = {
      rootMargin: `0px 0px -${window.innerHeight}px 0px`,
    }

    const callback = entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const transparentSetting = entry.target.dataset.transparentSiteHeader
          const foregroundTransparentSetting =
            entry.target.dataset.transparentSiteHeaderForeground
          if (transparentSetting === 'true') {
            this.siteHeader.classList.add(this.classes.transparent)
            this.siteHeader.classList.remove(this.classes.foregroundLight)
            this.siteHeader.classList.remove(this.classes.foregroundDark)
            foregroundTransparentSetting === 'light'
              ? this.siteHeader.classList.add(this.classes.foregroundLight)
              : this.siteHeader.classList.add(this.classes.foregroundDark)
          } else {
            this.removeTransparentState(this.siteHeader)
          }
        } else {
          if (entry.boundingClientRect.bottom < 0) {
            this.removeTransparentState(this.siteHeader)
          }
        }
      })
    }

    const observer = new IntersectionObserver(callback, options)

    this.sections.forEach(section => observer.observe(section))
  }

  removeTransparentState (el) {
    el.classList.remove(this.classes.transparent)
    el.classList.remove(this.classes.foregroundLight)
    el.classList.remove(this.classes.foregroundDark)
  }

  get siteHeader () {
    return document.querySelector(this.selectors.siteHeader)
  }

  get sections () {
    return document.querySelectorAll(this.selectors.section)
  }
}

// eslint-disable-next-line no-unused-vars
const headerTransparentInit = new HeaderTransparent()
